import { Divider, Grid, styled, Typography } from '@quillbot/design-system';
import React from 'react';
import { CitationSourceEnum } from 'src/citation-generator/types';
import { getCgBreakpointDown } from 'src/citation-generator/utils';
import { useEditFormState } from '../context';

const Separator = styled(Divider)`
  margin: 17px 10px;
  width: calc(100% + 28px);

  ${({ theme }) => getCgBreakpointDown(theme)} {
    width: 100%;
    margin: 12px 0;
  }
`;

const Heading = styled(Typography)`
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 8px;
  margin-left: 20px;

  ${({ theme }) => getCgBreakpointDown(theme)} {
    margin-left: 0;
  }
`;

export const Section = ({
  children,
  title,
  isAdvanced,
}: {
  children: React.ReactNode;
  title: string;
  isAdvanced?: boolean;
}) => {
  const sourceType = useEditFormState((state) => state.sourceType);

  if (isAdvanced && sourceType === CitationSourceEnum.WEBSITE) {
    return null;
  }

  return (
    <>
      <Separator />

      <Grid container item>
        <Heading>{title}</Heading>

        {children}
      </Grid>
    </>
  );
};

const StyledGrid = styled(Grid)`
  height: 16px;
  background: #f0d99e;
  border-radius: 3px;
  font-size: 9px;
  padding: 0px 6px;
  display: flex;

  ${({ theme }) => getCgBreakpointDown(theme)} {
    margin: 0px auto 12px;
  }
`;
export const WarningBanner = () => {
  const { isEdit, warnings, contributors } = useEditFormState((state) => state);

  if (
    isEdit &&
    ((warnings &&
      Object.values(warnings).some((w) => (Array.isArray(w) ? w.some(Boolean) : Boolean(w)))) ||
      contributors?.some((c) => !c.firstName || !c.lastName))
  ) {
    return (
      <StyledGrid item alignItems="center">
        We strongly suggest that you fill in the missing information
      </StyledGrid>
    );
  }

  return null;
};
